export default function parseDate(dateStr = '') {
  const [date, time = ''] = dateStr.split('T')
  const [year, month, day] = date.split('-')
  const [hours = '', minutes = '', secondsWithMilliseconds = ''] = time.split(':')
  const [seconds = '', milliseconds = ''] = secondsWithMilliseconds.split('.')
  const args = [year, month, day, hours, minutes, seconds, milliseconds.slice(0, 3)].map((str, index) => {
    const isMonth = index === 1
    const parsedValue = parseInt(str, 10) - (isMonth ? 1 : 0)
    return isNaN(parsedValue) ? 0 : parsedValue
  })
  return new Date(Date.UTC.apply(null, args))
}



// WEBPACK FOOTER //
// ./client/utils/parseDate.js